/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Globalsearch_Semantic_Heading1Inputs */

const id_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecocokan berdasarkan makna`)
};

const ms_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Padanan mengikut makna`)
};

const da_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matcher efter betydning`)
};

const de_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treffer nach Bedeutung`)
};

const en_us2_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matches by meaning`)
};

const es_es2_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coincidencias por significado`)
};

const es_mx2_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coincidencias por significado`)
};

const fil_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga tugma ayon sa kahulugan`)
};

const fr_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correspondances par sens`)
};

const it_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrispondenze per significato`)
};

const hu_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelentés szerinti találatok`)
};

const nl_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overeenkomsten op betekenis`)
};

const no_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treff etter betydning`)
};

const pl_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dopasowania według znaczenia`)
};

const pt_br2_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correspondências por significado`)
};

const pt_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correspondências por significado`)
};

const ro_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potriviri după sens`)
};

const fi_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkityksen perusteella löytyvät osumat`)
};

const sv_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matchningar efter betydelse`)
};

const vi_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kết quả khớp theo ý nghĩa`)
};

const tr_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anlama göre eşleşmeler`)
};

const cs_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shody podle významu`)
};

const bg_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Съвпадения по смисъл`)
};

const ru_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совпадения по смыслу`)
};

const uk_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Збіги за значенням`)
};

const ar_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مطابقات حسب المعنى`)
};

const hi_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अर्थ के आधार पर मिलान`)
};

const th_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการที่ตรงกันตามความหมาย`)
};

const ja_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`意味による一致`)
};

const zh_cn2_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按含义匹配`)
};

const zh_hant1_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依意義相符`)
};

const ko_globalsearch_semantic_heading1 = /** @type {(inputs: Globalsearch_Semantic_Heading1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`의미별 일치 항목`)
};

/**
* | output |
* | --- |
* | "Matches by meaning" |
*
* @param {Globalsearch_Semantic_Heading1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const globalsearch_semantic_heading1 = /** @type {((inputs?: Globalsearch_Semantic_Heading1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Globalsearch_Semantic_Heading1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_globalsearch_semantic_heading1(inputs)
	if (locale === "ms") return ms_globalsearch_semantic_heading1(inputs)
	if (locale === "da") return da_globalsearch_semantic_heading1(inputs)
	if (locale === "de") return de_globalsearch_semantic_heading1(inputs)
	if (locale === "en-US") return en_us2_globalsearch_semantic_heading1(inputs)
	if (locale === "es-ES") return es_es2_globalsearch_semantic_heading1(inputs)
	if (locale === "es-MX") return es_mx2_globalsearch_semantic_heading1(inputs)
	if (locale === "fil") return fil_globalsearch_semantic_heading1(inputs)
	if (locale === "fr") return fr_globalsearch_semantic_heading1(inputs)
	if (locale === "it") return it_globalsearch_semantic_heading1(inputs)
	if (locale === "hu") return hu_globalsearch_semantic_heading1(inputs)
	if (locale === "nl") return nl_globalsearch_semantic_heading1(inputs)
	if (locale === "no") return no_globalsearch_semantic_heading1(inputs)
	if (locale === "pl") return pl_globalsearch_semantic_heading1(inputs)
	if (locale === "pt-BR") return pt_br2_globalsearch_semantic_heading1(inputs)
	if (locale === "pt") return pt_globalsearch_semantic_heading1(inputs)
	if (locale === "ro") return ro_globalsearch_semantic_heading1(inputs)
	if (locale === "fi") return fi_globalsearch_semantic_heading1(inputs)
	if (locale === "sv") return sv_globalsearch_semantic_heading1(inputs)
	if (locale === "vi") return vi_globalsearch_semantic_heading1(inputs)
	if (locale === "tr") return tr_globalsearch_semantic_heading1(inputs)
	if (locale === "cs") return cs_globalsearch_semantic_heading1(inputs)
	if (locale === "bg") return bg_globalsearch_semantic_heading1(inputs)
	if (locale === "ru") return ru_globalsearch_semantic_heading1(inputs)
	if (locale === "uk") return uk_globalsearch_semantic_heading1(inputs)
	if (locale === "ar") return ar_globalsearch_semantic_heading1(inputs)
	if (locale === "hi") return hi_globalsearch_semantic_heading1(inputs)
	if (locale === "th") return th_globalsearch_semantic_heading1(inputs)
	if (locale === "ja") return ja_globalsearch_semantic_heading1(inputs)
	if (locale === "zh-CN") return zh_cn2_globalsearch_semantic_heading1(inputs)
	if (locale === "zh-Hant") return zh_hant1_globalsearch_semantic_heading1(inputs)
	return ko_globalsearch_semantic_heading1(inputs)
});
export { globalsearch_semantic_heading1 as "globalSearch.semantic.heading" }